import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import FormInput from '@/components/FormInput';

export default function ACHPaymentForm() {
  return (
    <Row>
      <Col xs={12}>
        <FormInput name="nameOnAccount" label="Name on Account" required />
      </Col>

      <Col xs={12}>
        <FormInput
          name="routingNumber"
          label="Routing Number"
          required
          pattern="[0-9]{9}"
          title="Routing number must be 9 digits"
        />
      </Col>

      <Col xs={12}>
        <FormInput
          name="accountNumber"
          label="Account Number"
          required
          pattern="[0-9]+"
          title="Account number must contain only digits"
        />
      </Col>

      <Col xs={12}>
        <FormGroup>
          <Label for="accountType">Account Type</Label>
          <Input
            type="select"
            name="accountType"
            id="accountType"
            defaultValue="checking"
            required
          >
            <option value="checking">Checking</option>
            <option value="savings">Savings</option>
          </Input>
        </FormGroup>
      </Col>
    </Row>
  );
}
